import { Loader } from "@mantine/core"
import { InfoBox } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { Mapping } from "~/pages/Admin/Mapping/Mapping"
import { useFindPendingMappingQuery } from "~/pages/Admin/Mapping/hooks/useFindPendingMappingQuery"

export function MappingWrapper() {
  const { t } = useTranslation()
  const { data, isPending: isLoading, isError } = useFindPendingMappingQuery()

  if (isLoading) {
    return <Loader />
  }

  if (isError) {
    return (
      <InfoBox
        title={t("dataLoad.noResults.title")}
        message={t("dataLoad.noResults.message")}
      />
    )
  }

  return <Mapping count={data.data.count} />
}
